// extracted by mini-css-extract-plugin
export default {"AboutCard":"AboutBlock_AboutCard__jnmhg"};